module.exports = __webpack_public_path__ + "static/media/7.552986a0.webp";